export default __webpack_public_path__ + "static/media/Animations_Bar8.52556cee.svg";